import React from 'react'
import {useCartContext} from '../context/CartContext'
import WishListItem from './WishListItem';
import IntroSections from '../IntroSections'

export const WishList = () => {

    const {wishListItems} = useCartContext();

    return (
        <>
            <IntroSections sectionName="WishList" sectionLink="WishList" />
      <div className='CartPage'>
        <div className='intro'>
                     <h3 className='Liked'>Favorite products <i  className="fa-solid fa-heart"></i></h3>
         </div>
          <div className='container'>
                <table  className="table table-bordered text-center mt-3">
        <thead className="bg-dark text-light">
            <tr>
            <td>Product</td>
            <td>Product name</td>
            <td>Price</td>
            <td>Categories</td>
            <td>Remove</td>     
            </tr>
             </thead>
         {
                  wishListItems.map((item) => {
                  return(
                  <tbody key={item.id}  >
                      <WishListItem {...item} />
                </tbody>
          )
              })


        }
             


        </table> 

</div>
          
          
            </div>
            </>
  )
}
